import type { FeedbackMessages } from './en';

const ro: FeedbackMessages = {
  qualified: {
    title: 'Vă mulțumim pentru finalizarea acestui studiu!',
    body1: 'Puteți închide fereastra browserului.',
    body2: 'Speram să vă revedem în curând.',
    refCode: 'Cod de referință: {code}',
  },
  quotaFull: {
    title: 'Acest studiu este închis',
    body1: 'Vă mulțumim pentru interesul acordat studiului nostru.',
    body2: 'Din păcate, am primit deja toate răspunsurile de care avem nevoie.',
    body3: 'Speram să vă revedem într-unul din studiile noastre viitoare!',
    refCode: 'Cod de referință: {code}',
  },
  terminated: {
    title: 'Vă mulțumim pentru feedback-ul dumneavoastră!',
    body1:
      'Speram să vă revedem în curând în studiile noastre viitoare. Până atunci, vă urăm o zi excelentă.',
    body2: 'Vă rugăm să închideți această fereastră a browserului.',
    refCode: 'Cod de referință: {code}',
  },
  mismatch: {
    title: 'Vă mulțumim pentru interesul dumneavoastră',
    body1: 'Din păcate, nu faceți parte din grupul țintă pentru acest studiu specific.',
    body2: 'Puteți închide această pagină.',
    code: 'Cod: {code}',
  },
  error: {
    title: 'Nu putem procesa solicitarea dumneavoastră',
    linkProblemDetailed:
      'Linkul pe care l-ați urmat are probleme. Vă rugăm să verificați că linkul din bara de adrese corespunde cu cel care v-a fost furnizat și încercați din nou.',
    linkProblemGeneric:
      'Linkul pe care l-ați urmat are probleme. Vă rugăm să încercați din nou.',
    contactPerson:
      'Dacă problema persistă, vă rugăm să informați persoana de la care ați primit linkul despre această problemă.',
    errorCode: 'Cod de eroare: {code}',
  },
};

export default ro;
